import { useContext, useEffect, useState } from "react";
import { loginContext, valueContext } from "../context/contexts";
import { Card } from "@mui/material";
import Profile from "./Profile";
import Devices from "./Devices";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import User from "./User";
import { boxStyle, Root, headerStyle, searchStyle } from "../style/style";
import { getobj } from "../apicall/apicall";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import CustomerHubs from "./CustomerComponent/CustomerHubs";
import OrganisationBilling from "./OrganisationBilling";
import CustomerStat from "./CustomerComponent/CustomerStat";
import BulkDeviceImport from "./BulkDeviceImport";

export default function UserDetail() {
  const [customerDetails, setCustomerDetails] = useState();
  const [loaded, setloaded] = useState(true);

  const [value, setvalue] = useState(
    sessionStorage.getItem("value") === "5"
      ? sessionStorage.getItem("value")
      : "1",
  );
  const [search, setsearch] = useState(
    value === "1"
      ? sessionStorage.getItem("search_devices")
        ? sessionStorage.getItem("search_devices")
        : ""
      : "",
  );
  const [enter, setenter] = useState(
    value === "1"
      ? sessionStorage.getItem("search_devices")
        ? true
        : false
      : false,
  );

  const id = useContext(loginContext);

  useEffect(() => {
    id.setid(id.customer_id);
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + id.id + "/";
    const d = getobj(url);
    d.then(function (res) {
      setCustomerDetails(res.data);
      setloaded(false);
    });

    setloaded(false);
  }, [value, id]);
  const handleSearch = (e) => {
    setenter(false);
    setsearch(e.target.value);
    if (e.target.value === "") {
      setenter(true);
      sessionStorage.removeItem("search_devices");
    }
  };

  const tabChange = (value) => {
    sessionStorage.setItem("page_number", 1);
    sessionStorage.removeItem("search_devices");

    setenter(false);
    setsearch("");
    setvalue(value);
  };
  return (
    <valueContext.Provider
      value={{
        value: value,
        setvalue: setvalue,
      }}
    >
      <Root>
        {loaded ? (
          <img
            src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
            alt="loading..."
          />
        ) : (
          <Root>
            <Card sx={boxStyle}>
              <Card sx={headerStyle}>
                {customerDetails && customerDetails.company_name}
                <form
                  style={searchStyle}
                  onSubmit={(e) => {
                    e.preventDefault();
                    sessionStorage.setItem("search_devices", search);
                    setenter(true);
                  }}
                >
                  <FormControl variant="standard" sx={searchStyle}>
                    <InputLabel htmlFor="input-with-icon-adornment">
                      Search ...
                    </InputLabel>
                    <Input
                      id="input-with-icon-adornment"
                      startAdornment={
                        <InputAdornment position="start">
                          <SearchSharpIcon color="primary" />
                        </InputAdornment>
                      }
                      value={search}
                      onChange={handleSearch}
                    />
                  </FormControl>
                </form>
              </Card>
            </Card>
            <Card sx={boxStyle}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList value={value}>
                    <Tab
                      label="Devices"
                      value={"1"}
                      onClick={() => tabChange("1")}
                    />
                    <Tab
                      label="Hubs"
                      value={"5"}
                      onClick={() => tabChange("5")}
                    />
                    <Tab
                      label="profile"
                      value={"2"}
                      onClick={() => tabChange("2")}
                    />
                    <Tab
                      label="DashBoard"
                      value={"4"}
                      onClick={() => tabChange("4")}
                    />
                    <Tab
                      label="Users"
                      value={"3"}
                      onClick={() => tabChange("3")}
                    />
                    {/* <Tab
                      label="Monthly Stat"
                      value={"7"}
                      onClick={() => tabChange("7")}
                    /> */}
                    <Tab
                      label="Reports"
                      value={"6"}
                      onClick={() => tabChange("6")}
                    />
                    <Tab
                      label="BULK DEVICE IMPORT"
                      value={"7"}
                      onClick={() => tabChange("7")}
                    />
                  </TabList>
                </Box>
                <TabPanel value="2">
                  <Profile id={id.id} />
                </TabPanel>
                <TabPanel value="1">
                  <Root>
                    <Devices
                      id={id.id}
                      search={enter ? search : ""}
                      customerDetails={customerDetails}
                    />
                  </Root>
                </TabPanel>
                <TabPanel value="3">
                  <User id={id.id} search={enter ? search : ""} />
                </TabPanel>
                <TabPanel value="4">
                  <CustomerStat id={id.id} />
                </TabPanel>
                <TabPanel value="5">
                  <CustomerHubs id={id.id} search={enter ? search : ""} />
                </TabPanel>
                <TabPanel value="6">
                  <OrganisationBilling
                    id={id.id}
                    customerDetails={customerDetails}
                  />
                </TabPanel>
                {/* <TabPanel value="7">
                  <MonthlyStats id={id.id} />
                </TabPanel> */}
                <TabPanel value="7">
                  <BulkDeviceImport id={id.id} />
                </TabPanel>
              </TabContext>
            </Card>
          </Root>
        )}
      </Root>
    </valueContext.Provider>
  );
}
